import type { MessageDto } from '../api/types';

type ScrollMessage = Pick<MessageDto, 'id' | 'senderId'>;

// Счётчик не включает свои сообщения: отсчитываем хвост только среди входящих.
export function unreadMessages<T extends ScrollMessage>(messages: T[], unreadCount: number, userId?: string): T[] {
  if (unreadCount <= 0) return [];
  return messages.filter(message => message.senderId !== userId).slice(-unreadCount);
}

export function scrollDownTarget(messages: ScrollMessage[], unreadIds: number[]): number | null {
  return unreadIds[unreadIds.length - 1] ?? messages[messages.length - 1]?.id ?? null;
}

export function remainingUnreadCount(messages: ScrollMessage[], unreadCount: number, messageId: number, userId?: string): number {
  if (messages.length === 0 || messageId < messages[0].id) return unreadCount;
  return Math.min(unreadCount, messages.filter(message => message.senderId !== userId && message.id > messageId).length);
}
